export function hasElements<T>(array?: unknown[] | unknown): array is T[] {
  return Array.isArray(array) && array.length > 0;
}
